// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"195":"63923dc3b096ea2d","203":"2e4ff5234d2437e6","552":"f29b66d8c793d305"}[chunkId] + ".css";
};